import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ActionSeverity, capturePageAction } from '@chegg/observability';
export var makeApolloClientRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apolloClient, queryOptions, params) {
    var result, teamName, location;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return apolloClient.query(queryOptions);
        case 3:
          result = _context.sent;
          if (result.error) {
            logError(result.error, params);
          }
          return _context.abrupt("return", result);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          teamName = params.teamName, location = params.location;
          capturePageAction({
            action: _context.t0,
            location: location,
            severity: ActionSeverity.WARNING
          }, {
            teamName: teamName
          });
          throw _context.t0;
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function makeApolloClientRequest(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var logError = function logError(error, params) {
  var teamName = params.teamName,
    location = params.location;
  capturePageAction({
    action: error,
    location: location,
    severity: ActionSeverity.WARNING
  }, {
    teamName: teamName
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/SubscriptionUtil/apolloClientHelper.js
// module id = 1444
// module chunks = 11